const hijab = [
  { value: "Always with niqab", label: "Always with niqab" },
  { value: "Always hijab", label: "Always hijab" },
  { value: "Sometimes", label: "Sometimes" },
  { value: "No", label: "No" },
];
export default hijab;
